var _a, _b;
import { __assign, __spreadArrays } from "tslib";
import { handleActions } from 'redux-actions';
import pick from 'lodash/pick';
import { addNotificationToQueue, removeNotificationFromQueue, removeQueues, } from './actionCreators';
import { reduxKey } from './constants';
var MAX_NOTIFICATION_AGE = 60000;
function isValidNotification(item) {
    // do not expire notifications during tests
    if (process.env.NODE_ENV === 'test') {
        return true;
    }
    return Date.now() - item.created > MAX_NOTIFICATION_AGE;
}
var handler = handleActions((_a = {},
    _a[addNotificationToQueue.toString()] = function (state, _a) {
        var _b;
        var _c = _a.payload, notification = _c.notification, queueName = _c.queueName;
        var queue = (state[queueName] || []).filter(isValidNotification);
        return __assign(__assign({}, state), (_b = {}, _b[queueName] = __spreadArrays(queue, [notification]), _b));
    },
    _a[removeNotificationFromQueue.toString()] = function (state, _a) {
        var _b;
        var _c = _a.payload, queueName = _c.queueName, id = _c.id;
        if (!state[queueName]) {
            return state;
        }
        var queue = state[queueName].filter(isValidNotification);
        return __assign(__assign({}, state), (_b = {}, _b[queueName] = queue.filter(function (item) { return item.id !== id; }), _b));
    },
    _a[removeQueues.toString()] = function (state, _a) {
        var predicate = _a.payload.predicate;
        var queues = Object.keys(state).filter(function (queueName) {
            return queueName === 'default' ? true : !predicate(queueName);
        });
        // Inferred typing on pick here is a bit bad
        return pick(state, queues);
    },
    _a), { default: [] });
export default (_b = {},
    _b[reduxKey] = handler,
    _b);
//# sourceMappingURL=reducer.js.map